import {GenericMenuItem} from "../interfaces/genericMenuItem.ts";


export const preferencesItems: GenericMenuItem[] = [
  {
    id: "edit-profile",
    title: "Edit profile",
    icon: "profile",
  },
  {
    id: "password",
    title: "Password",
    icon: "lock-1",
  },
  {
    id: "notifications",
    title: "Notifications",
    icon: "bell",
  },
  {
    id: "team",
    title: "Team",
    icon: "users-plus",
  },
  {
    id: "sessions",
    title: "Sessions",
    icon: "log-in",
  },
  {
    id: "appearance",
    title: "Appearance",
    icon: "sun",
  },
  {
    id: "applications",
    title: "Applications",
    icon: "container",
  },
  {
    id: "delete-account",
    title: "Delete account",
    icon: "close-fat",
  },
];
